import api from "./api";

// Super-Admin-only, cross-tenant. The api instance still stamps the caller's own
// `company` header, but the backend ignores it for this route (it reports across
// every tenant and is gated by the Super Admin guard).
const list = () => {
  return api.get("/api/platform/app-version/list");
};

const AppVersionService = {
  list,
};

export default AppVersionService;
